<script>
import LocaleSelect from '@components/locale-select'
export default {
  components: { LocaleSelect },
  mounted() {
    document.body.classList.add(this.$style.bodyAdmin)
  },
  beforeDestroy() {
    document.body.classList.remove(this.$style.bodyAdmin)
  },
}
</script>

<template>
  <div :class="[$style.ec, $style.adminRoot]">
    <div :class="[$style.header]">
      <h1 :class="[$style.xeAdmin]"><a href="#">Xchange</a></h1>

      <ul :class="[$style.gnb]">
        <li>
          <LocaleSelect></LocaleSelect>
        </li>
        <li
          ><router-link :to="{ name: 'logout' }" :class="[$style.link]">{{
            $t('admin_main.sign_out')
          }}</router-link></li
        >
      </ul>
      <ul v-if="0" :class="[$style.lnb]">
        <li :class="[$style.core, $style.selected]"
          ><a href="#">{{ $t('admin_main.control_panel') }}</a></li
        >
        <li :class="[$style.core]"
          ><a href="#">{{ $t('admin_main.board') }}</a></li
        >
      </ul>
    </div>
    <hr />
    <div :class="[$style.body]">
      <div :class="[$style.extension, $style.e1]">
        <div :class="[$style.section]">
          <div :class="$style.searchNav">
            <input type="text" size="12" />
            <button type="button"></button>
          </div>
          <ul :class="[$style.navigation]">
            <li :class="[$style.parent, $style.active, $style.module_member]"
              ><a href="#" :class="[$style.parent]">CRM</a>
              <ul>
                <li
                  ><router-link
                    :to="{ name: 'admin-member-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.member') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-member-group-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.membership_group') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-loginlog-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.login_list') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-oauth2-client-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.OAuth2_client') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-activity-log-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.activity_log') }}</router-link
                  ></li
                >
                <li>
                  <router-link
                    :to="{ name: 'admin-config-cs' }"
                    :active-class="$style.active"
                    >CS</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-cs-ticket-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.cs_inquiry_history') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-cs-faq-list' }"
                    :active-class="$style.active"
                    >CS FAQ</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-contract-catalog' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.contract') }}</router-link
                  >
                </li>
              </ul>
            </li>
            <li :class="[$style.parent, $style.active, $style.module_service]">
              <a href="#" :class="[$style.parent]">{{
                $t('admin_main.pr_affiliate')
              }}</a>
              <ul>
                <li>
                  <router-link
                    :to="{ name: 'admin-affiliate-policy' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.allowance_policy') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-affiliate-log-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.benefit_details') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-affiliate-balance-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.allowance_balance') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-affiliate-adjust-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.allowance_settlement') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-brokerage-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.broker') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-brokerage-balance-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.brokerage_balance') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-brokerage-share-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.brokers_equity') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-brokerage-adjust-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.brokerage_settlement') }}</router-link
                  >
                </li>
              </ul>
            </li>
            <li :class="[$style.parent, $style.active, $style.module_service]">
              <a href="#" :class="[$style.parent]">{{
                $t('admin_main.payment_payment')
              }}</a>
              <ul>
                <li>
                  <router-link
                    :to="{ name: 'admin-pg-merchant-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.store') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-pg-feeset' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.fee') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-pg-transaction-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.transaction_history') }}</router-link
                  >
                </li>
              </ul>
            </li>
            <li :class="[$style.parent, $style.active, $style.module_content]"
              ><a href="#" :class="[$style.parent]">{{
                $t('admin_main.trade')
              }}</a>
              <ul>
                <li
                  ><router-link
                    :to="{ name: 'admin-private-deal-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.c2c_deal_list') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-private-application-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.c2c_app_list') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-direct-transfer-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.transfer_list') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-market' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.market') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-asset-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.asset_management') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-asset-plugin-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.plug_in') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-public-order-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.order_history') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-public-trade-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.engagement_details') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-public-balance-transfer-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.movement_history') }}</router-link
                  ></li
                >
              </ul>
            </li>
            <li :class="[$style.parent, $style.module_construction]"
              ><a href="#" :class="[$style.parent]">{{
                $t('admin_main.security')
              }}</a>
              <ul>
                <li
                  ><router-link
                    :to="{ name: 'admin-kyc-certification-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.kyc_cdd') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-kyc-realname-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.kyc_real_name') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{
                      name:
                        'admin-kyc-asset-withdraw-address-certification-list',
                    }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.kyc_withdraw') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-security' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.security_restriction') }}</router-link
                  ></li
                >
              </ul>
            </li>
            <li :class="[$style.parent, $style.active, $style.module_service]"
              ><a href="#" :class="[$style.parent]">{{
                $t('admin_main.financial_management')
              }}</a>
              <ul>
                <li
                  ><router-link
                    :to="{ name: 'admin-finance-catalog' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.finance') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-account-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.account') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-deposit-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.deposit_list') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-withdraw-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.withdraw_list') }}</router-link
                  ></li
                >
                <li>
                  <router-link
                    :to="{ name: 'admin-account-transfer-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.transfer_details') }}</router-link
                  >
                </li>
                <li
                  ><router-link
                    :to="{ name: 'admin-withdraw-transfer-list' }"
                    :active-class="$style.active"
                    >{{
                      $t('admin_main.withdrawal_transmission_history')
                    }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-withdraw-policy' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.withdrawal_policy') }}</router-link
                  ></li
                >
              </ul>
            </li>
            <li :class="[$style.parent, $style.active, $style.module_accessory]"
              ><a href="#" :class="[$style.parent]">{{
                $t('admin_main.site')
              }}</a>
              <ul>
                <li :class="[$style.active]">
                  <router-link
                    :to="{ name: 'admin-acs-catalog' }"
                    :active-class="$style.active"
                    >{{
                      $t('admin_main.manageability_access_control')
                    }}</router-link
                  >
                </li>
                <li :class="[$style.active]">
                  <router-link
                    :to="{ name: 'admin-lang-list' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.lang') }}</router-link
                  >
                </li>
                <li :class="[$style.active]">
                  <router-link
                    :to="{ name: 'admin-statistic' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.settlement_statistics') }}</router-link
                  >
                </li>
              </ul>
            </li>
            <li :class="[$style.parent, $style.module_system]"
              ><a href="#" :class="[$style.parent]">{{
                $t('admin_main.setting')
              }}</a>
              <ul>
                <li
                  ><router-link
                    :to="{ name: 'admin-config-member' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.member') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-config-service' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.service') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-config-kyc' }"
                    :active-class="$style.active"
                    >KYC</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-config-mail' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.mail') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-config-phone' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.phone') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-config-notification' }"
                    :active-class="$style.active"
                    >{{ $t('admin_main.alert') }}</router-link
                  ></li
                >
                <li
                  ><router-link
                    :to="{ name: 'admin-config-otp' }"
                    :active-class="$style.active"
                    >OTP</router-link
                  ></li
                >
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <hr />
      <div :class="[$style.content]">
        <p :class="[$style.path]">
          <a href="#">{{ $t('admin_main.admin') }}</a>
        </p>
        <slot />
      </div>
    </div>
    <hr />
    <div :class="[$style.footer]">
      <address
        ><a href="#">Powered by <strong>X</strong>change</a></address
      >
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/layout.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';

.bodyAdmin {
  background-color: transparent;
}
.bodyAdmin select {
  appearance: menulist;
}
.link {
  font-size: 14px !important;
  line-height: 2.2;
  color: #fff !important;
}
</style>
